import { Reveal, SectionHeading } from "./Primitives";
import { FAQS } from "@/data/content";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQ = () => (
  <section id="faq" className="bg-[#0a0a0a] border-y border-white/10 py-20 md:py-32">
    <div className="mx-auto max-w-[900px] px-5 md:px-10">
      <Reveal>
        <SectionHeading
          overline="FAQ"
          title={<>Questions, <span className="gold-gradient italic">answered</span></>}
          center
        />
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12 w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-white/10"
            >
              <AccordionTrigger className="text-left text-base md:text-lg text-white hover:text-gold hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm md:text-base text-zinc-400 leading-relaxed pb-5">
                <div className="space-y-3">
                  {f.a.split("\n\n").map((p, j) => (
                    <p key={j}>{p}</p>
                  ))}
                </div>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
